import 'core-js/stable';
import 'regenerator-runtime/runtime';

// @ts-ignore
import { initPulseButton } from '../landings/widgets/pulseButton';
import { initDontoutPopup } from '../landings/widgets/retentionPopup';
import { LandingPreloader } from '../landings/widgets/LandingPreloader';
import '../landings/forms/registrationV124';
import '../landings/forms/registrationDouble';
import '../landings/forms/registrationInteractiveBattle';
import '../general/sites_index';
import '../vendor/jquery.cookie-1.4.1';
import '../vendor/jquery.scrollbar-0.2.10';
import '../general/modules/jsClick';
import '../general/modules/parallaxBackground';
import '../general/handlers/restoreFormHandler';
import '../general/modules/utilityFunctions';
import '../general/modules/languageSelect';
import '../supportTicket/supportWindowMobile';
import { calcBackground } from '../general/calcIndexBackAndPopup';
import { LandingType } from '../constants/LandingTypes';
import { initSupportTicketWindow } from '../supportTicket/supportWindowLandings';
import { addLoginCallback } from '../login/common';
import { CommonLpHandler } from '../landings/lpPageHandlers/commonLpHandler';
import { GtmSender } from '../marketing/GtmSender';
import { SystemEvents } from '../constants/gameEvents';
import { guestWebAuth } from '../login/guest';
import { container } from '../utils/container/container';
import { FeatureFlagsLoader } from '../utils/feature-flags/feature-flags-loader';
import { FlagNames } from '../utils/feature-flags/flag-names';
import {ServiceIds} from '../utils/container/service-ids';
import { initDelayedDeletionPopupHandler } from "../general/handlers/delayedDelitonPopupHandler";
import {initOtpForm} from "../general/handlers/otpFormHandler";
import { initRegistrationFormHandler } from "../general/handlers/registrationFormHandler";


async function instantExecute(): Promise<void> {
    if (window.app.config.landings.landingType === LandingType.INSTANT_REG) {
        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const flag = ffLoader.get(FlagNames.WEB_GUEST_ACCOUNTS);
        if (flag.isOn()) {
            await guestWebAuth();
        } else {
            location.replace(window.app.config.landings.redirect_url);
        }
    }

    if (window.app.config.landings?.lpPreloader?.enablePreloader) {
        const landingPreloader = new LandingPreloader();
        landingPreloader.init();
    }
}

instantExecute();

async function getLpHandler() {
    let lpHandler;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let handlerConstructor: any;

    switch (window.app.config.landings.landingType) {
        case LandingType.INTERACTIVE_MAP:
            handlerConstructor = await import('../landings/lpPageHandlers/interactiveMapLPHandler');
            lpHandler = new handlerConstructor.InteractiveMapLPHandler();
            break;
        case LandingType.EMAIL_GATHER:
            handlerConstructor = await import('../landings/lpPageHandlers/gatherEmailLPHandler');
            lpHandler = new handlerConstructor.GatherEmailLPHandler();
            break;
        case LandingType.ACTOR_SELECT:
            handlerConstructor = await import('../landings/lpPageHandlers/actorSelection');
            lpHandler = new handlerConstructor.ActorSelectLpHandler();
            break;
        case LandingType.VIDEO:
            handlerConstructor = await import('../landings/lpPageHandlers/videoLpHandler');
            lpHandler = new handlerConstructor.VideoLpHandler();
            break;
        case LandingType.LANDSHIFT:
            handlerConstructor = await import('../landings/lpPageHandlers/ShiftLpHandler');
            lpHandler = new handlerConstructor.ShiftLpHandler();
            break;
        case LandingType.INTERACTIVE_BATTLE:
            handlerConstructor = await import('../landings/lpPageHandlers/interactiveBattleLpHandler');
            lpHandler = new handlerConstructor.InteractiveBattleLpHandler();
            break;
        case LandingType.INTERACTIVE_PUZZLE:
            handlerConstructor = await import('../landings/lpPageHandlers/interactivePuzzleHandler');
            lpHandler = new handlerConstructor.InteractivePuzzleHandler();
            break;
        case LandingType.INTERACTIVE_ONE_MAP:
            handlerConstructor = await import('../landings/lpPageHandlers/interactiveOneMap');
            lpHandler = new handlerConstructor.InteractiveOneMap();
            break;
        case LandingType.PRELAND:
            handlerConstructor = await import('../landings/lpPageHandlers/prelandHandler');
            lpHandler = new handlerConstructor.PrelandLpHandler();
            break;
        case LandingType.MOBILE:
            handlerConstructor = await import('../landings/lpPageHandlers/mobileLpHandler');
            lpHandler = new handlerConstructor.MobileLpHandler();
            break;
        case LandingType.INSTANT_REG:
            handlerConstructor = await import('../landings/lpPageHandlers/instantLpHandler');
            lpHandler = new handlerConstructor.InstantLpHandler();
            break;
        case LandingType.GAMBLE_CHESTS:
            handlerConstructor = await import('../landings/lpPageHandlers/GambleLpHandler');
            lpHandler = new handlerConstructor.GambleLpHandler();
            break;
        default:
            console.error(`${window.app.config.landings.landingType} lpHandler not initialized`);
    }

    return lpHandler;
}

function onClickOutsideContactsPopup(event: Event) {
    const $target = $(event.target);
    const $contacts = $('#contacts');

    if (
        $contacts.is(':visible') &&
        // @ts-ignore
        !$contacts.has($target).length
    ) {
        $contacts.hide();
    }
}

async function commonSocialLoginCallback() {
    GtmSender.fireMarketing(SystemEvents.REGISTRATION);
}

function launchResizeFixer() {
    const RESIZE_TICK_TIME = 1000;
    const RESIZE_FIX_DISABLE_TIMEOUT = 5000;
    const isInteractiveMapLandingType = window.app.config.landings.landingType !== LandingType.INTERACTIVE_MAP &&
        window.app.config.landings.landingType !== LandingType.INTERACTIVE_ONE_MAP;

    if (isInteractiveMapLandingType && !isArticleLanding()) {
        const resizeFixInterval = setInterval(() => {
            calcBackground();
        }, RESIZE_TICK_TIME);
        setTimeout(() => {
            clearInterval(resizeFixInterval);
        }, RESIZE_FIX_DISABLE_TIMEOUT);
    }
}

function isArticleLanding() {
    return location.href.includes('article') === true;
}

const handlerLoading = getLpHandler();

$(async function lpOnDocumentReady() {
    const commonLpHandler = new CommonLpHandler();
    launchResizeFixer();
    commonLpHandler.run();

    const lpHandler = await handlerLoading;
    if (lpHandler) {
        console.log('run handler');
        lpHandler.run();
    }

    if (window.app.config.lpvariant && window.app.config.lpvariant === 'article') {
        $('#registration .js-close-button').on('click', function handleArticleRegistrationCloseButton() {
            $('#registration').hide();
        });
    }

    if (window.app.config.landings.dontoutPopupEnabled) {
        initDontoutPopup();
    }

    if (window.app.config.landings.pulseButtonEnabled) {
        try {
            initPulseButton();
        } catch (error) {
            window.Sentry.captureException(error);
            console.error(error);
        }
    }

    $('.scrollbar-rail').scrollbar();
    $('#js_bottom_but').on('click', function onFooterButtonClick() {
        window.scrollTo(0, $('#registration').offset().top);
    });

    initSupportTicketWindow();
    initDelayedDeletionPopupHandler();
    $(document).on('click', onClickOutsideContactsPopup);

    $('video').on('click', function preventVideoControlTrigger(event) {
        event.preventDefault();
        return false;
    });

    $('#registration .js-reload-button').on('click', function handleReloadButtonClick() {
        location.href = window.location.href;
    });

    $('#registration .js-download-button').on('click', function handleDownloadButtonClick() {
        window.app.downloadLauncher();
    });

    initOtpForm();

    addLoginCallback(commonSocialLoginCallback);

    if (isArticleLanding()) {
        import((`../vendor/jquery.fancybox.min.js`));
    }

    initRegistrationFormHandler();
});
